import React from "react";
import SystemChip from "../../../widgets/SystemChip";
import {
  ADD_COLOR,
  GET_COLOR_CLS,
  UPDATE_COLOR,
  DELETE_COLOR,
} from "../../../../backend/graphql";
import {
  GraphQLDataGrid,
  GraphQLGridParameters,
} from "../../../widgets/GraphQLDataGrid";

import { useAppSelector } from "../../../../app/hooks";
import { isReadonly } from "../../../../app/features/auth/authTypes";

const COLOR_SYSTEMS = ["GIA", "Langerman", "Flat", "Melee"];

const gridParameters: GraphQLGridParameters = {
  graphqlQuery: GET_COLOR_CLS,
  graphqlItemsPath: (data) => data.colorCls,
  graphqlUpdate: UPDATE_COLOR,
  graphqlUpdatePath: (data) => data.updateColor,
  graphqlAdd: ADD_COLOR,
  graphqlAddPath: (data) => data.addColor,
  graphqlDelete: DELETE_COLOR,
  fields: [
    { field: "id", label: "ID", visible: false, width: 300, type: "uuid" },
    {
      field: "system",
      label: "System",
      width: 140,
      type: "singleSelect",
      valueOptions: COLOR_SYSTEMS,
      editableForNew: true,
      defaultSort: "asc",
      renderCell: (params: any) =>
        params.value ? <SystemChip system={params.value} /> : null,
    },
    {
      field: "color",
      label: "Color",
      editableForNew: true,
    },
    {
      field: "valid",
      label: "Valid",
      type: "boolean",
      editable: true,
      width: 80,
    },
    {
      field: "exceptional",
      label: "Exceptional",
      type: "boolean",
      editable: true,
      width: 110,
    },
  ],
};

// A read-only user sees the colors, with nothing to add, edit or delete.
const readonlyParameters: GraphQLGridParameters = {
  graphqlQuery: gridParameters.graphqlQuery,
  graphqlItemsPath: gridParameters.graphqlItemsPath,
  fields: gridParameters.fields.map((field) => ({
    ...field,
    editable: false,
    editableForNew: false,
  })),
};

const ColorsTab: React.FC = () => {
  const readonly = isReadonly(useAppSelector((state) => state.auth.role));
  return (
    <GraphQLDataGrid
      parameters={readonly ? readonlyParameters : gridParameters}
    />
  );
};

export default ColorsTab;
